import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Constants } from '../../../constants'; 

@Component({
  selector: 'app-mi-perfil-popup',
  templateUrl: './mi-perfil-popup.component.html',
  styleUrls: ['./mi-perfil-popup.component.css']
})
export class MiPerfilPopupComponent {
  @Input() selectedOption: string = ''; 
  @Output() close = new EventEmitter<void>();

  miPerfil =  Constants.MI_PERFIL;
  soporte =  Constants.SOPORTE;
  acercaDe =  Constants.ACERCA_DE;
  manualUsuario = Constants.MANUAL_USUARIO;
  faq = Constants.FAQ;
  configuracion = Constants.CONFIGURACION;

  opciones = [
    this.miPerfil,
    this.soporte,
    this.acercaDe,
    this.faq
  ];

  isLeftPanelCollapsed = false; 

  seleccionarOpcion(opcion: string) {
    this.selectedOption = opcion;
  }

  closePopup() {
    this.close.emit();
  }

  toggleLeftPanel() {
   this.isLeftPanelCollapsed = !this.isLeftPanelCollapsed; 
  }

  getIconClass(opcion: string) {
    switch(opcion) {
      case Constants.MI_PERFIL:
        return 'ti-user'; 
      case Constants.SOPORTE:
        return 'ti-headphone-alt';
      case Constants.ACERCA_DE:
        return 'ti-info-alt'; 
      case Constants.MANUAL_USUARIO:
        return 'ti-file'; 
      case Constants.FAQ:
        return 'ti-help';
      default:
        return 'ti-shortcode';
    }
  }
}
